import { TabPanels, TabPanel, TabList, TabGroup, Tab } from '../Tabs';
import { useEffect, useState } from 'react';
import { fetchClinic } from '../../providers/clinics';
import GeneralTab from './GeneralTab';
import ScheduleTab from './ScheduleTab';
import SpecialtiesTab from './SpecialtiesTab';
import InsurersTab from './InsurersTab';
import ImagesTab from './ImagesTab';
import AppointmentsTab from './AppointmentsTab';
import { useTranslations } from '../../providers/i18n';

function ClinicForm({ id: clinicId, currentTab }) {
    const [t, translationsLoaded] = useTranslations('clinic-form');
    const [clinic, setClinic] = useState({});

    useEffect(() => {
        if (clinicId) {
            fetchClinic(clinicId).then(setClinic);
        }
    }, []);

    if (clinicId && !clinic.id) return null;
    if (!translationsLoaded) return null;

    return (
        <TabGroup className="flex flex-col h-full" tabKey="clinicFormTab" defaultIndex={currentTab}>
            <TabList className="mx-4 overflow-auto whitespace-nowrap">
                <Tab>{t('tabs.general')}</Tab>
                <Tab>{t('tabs.images')}</Tab>
                <Tab>{t('tabs.schedule')}</Tab>
                <Tab>{t('tabs.specialties')}</Tab>
                <Tab>{t('tabs.appointments')}</Tab>
                <Tab>{t('tabs.insurers')}</Tab>
            </TabList>
            <TabPanels className="flex-1 p-4 overflow-auto">
                <TabPanel>
                    <GeneralTab clinic={clinic} setClinic={setClinic} t={t} />
                </TabPanel>
                <TabPanel>
                    <ImagesTab logo={clinic?.logo} featuredImage={clinic?.featured_image} coverImages={clinic?.cover_images} t={t} />
                </TabPanel>
                <TabPanel>
                    <ScheduleTab schedule={clinic?.schedule} t={t} />
                </TabPanel>
                <TabPanel>
                    <SpecialtiesTab specialties={clinic?.specialties} t={t} />
                </TabPanel>
                <TabPanel>
                    <AppointmentsTab clinic={clinic} t={t} />
                </TabPanel>
                <TabPanel>
                    <InsurersTab insurers={clinic?.insurers} t={t} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
}

export default ClinicForm;
